import { loginByUsername, logout, dingTalkLogin } from '@/api/login'
import { getUserDetailInfo } from '@/api/user'
import { getAllChannel } from '@/api/channel'
import { getUserMessageList } from '@/api/message'
import { formatDate } from '@/utils/util'
import { getToken, setUserInfo, removeUserInfo } from '@/utils/user-info'
import { ROLE, CHANNEL_TYPE, CHANNEL_GRADE } from '@/utils/enum'
const user = {
  state: {
    user: '',
    status: '',
    code: '',
    token: getToken(),
    name: '',
    avatar: '',
    topRole: null,
    roles: [],
    setting: {
      articlePlatform: []
    },
    username: '',
    email: '',
    phoneNumber: '',
    id: '',
    userDetailInfoGetted: false,
    userInfoGetted: false,
    userDetailInfoId: '',
    unReadMsg: [],
    unReadMsgNum: 0,
    detailMsg: '',
    channelInfo: {}
  },
  getters: {
    isChannelTwoUser (state) {
      return ROLE.ROLE_CHANNEL_TWO.equal(state.topRole)
    },
    isChannelOneUser (state) {
      return ROLE.ROLE_CHANNEL_ONE.equal(state.topRole)
    },
    isChannelAdminUser (state) {
      return ROLE.ROLE_CHANNEL_ADMIN.equal(state.topRole)
    },
    isSuperUser (state) {
      return state.roles.indexOf(ROLE.ROLE_SYSTEMMANAGER.value) >= 0
    },
    isChannelUser (state) {
      return ROLE.ROLE_CHANNEL_ADMIN.equal(state.topRole) ||
      ROLE.ROLE_CHANNEL_ONE.equal(state.topRole) ||
      ROLE.ROLE_CHANNEL_TWO.equal(state.topRole)
    },
    isChannelUserOrAdmin (state) {
      return state.roles.indexOf(ROLE.ROLE_CHANNEL_ADMIN.value) >= 0 ||
      state.roles.indexOf(ROLE.ROLE_SYSTEMMANAGER.value) >= 0 ||
      state.roles.indexOf(ROLE.ROLE_CHANNEL_ONE.value) >= 0 ||
      state.roles.indexOf(ROLE.ROLE_CHANNEL_TWO.value) >= 0
    }
  },
  mutations: {
    SET_CODE: (state, code) => {
      state.code = code
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_USERNAME: (state, username) => {
      state.username = username
    },
    SET_EMAIL: (state, email) => {
      state.email = email
    },
    SET_PHONENUMBER: (state, phoneNumber) => {
      state.phoneNumber = phoneNumber
    },
    SET_USER_DETAIL_INFO_GETTED: (state, flag) => {
      state.userDetailInfoGetted = flag
    },
    SET_ID: (state, id) => {
      state.id = id
    },
    SET_USER_INFO: (state, userInfo) => {
      state.id = userInfo.id
      state.token = userInfo.token
      state.username = userInfo.username
      state.email = userInfo.email
      state.phoneNumber = userInfo.phoneNumber
      if (Array.isArray(userInfo.role)) {
        let roles = userInfo.role
        if (roles.indexOf(ROLE.ROLE_SYSTEMMANAGER.value) >= 0) state.topRole = ROLE.ROLE_SYSTEMMANAGER.value
        else if (roles.indexOf(ROLE.ROLE_CHANNEL_ADMIN.value) >= 0) state.topRole = ROLE.ROLE_CHANNEL_ADMIN.value
        else if (roles.indexOf(ROLE.ROLE_CHANNEL_ONE.value) >= 0) state.topRole = ROLE.ROLE_CHANNEL_ONE.value
        else if (roles.indexOf(ROLE.ROLE_CHANNEL_TWO.value) >= 0) state.topRole = ROLE.ROLE_CHANNEL_TWO.value
        roles = userInfo.role
        state.roles = roles
      }
      state.userInfoGetted = true
    },
    SET_UNREAD_MSG: (state, msg) => {
      state.unReadMsg = msg
    },
    SET_UNREAD_MSG_NUM: (state, num) => {
      state.unReadMsgNum = num
    },
    SET_DETAIL_MSG: (state, id) => {
      state.detailMsg = id
    },
    SET_CHANNEL_INFO: (state, obj) => {
      if (obj) {
        obj.created = formatDate(obj.created)
        obj.channelTypeText = CHANNEL_TYPE.getName(obj.channelType) || ''
        obj.gradeText = CHANNEL_GRADE.getName(obj.grade) || ''
      }
      state.channelInfo = obj || {}
    }
  },

  actions: {
    canEnter ({ getters }, loginInfo) {
      let canEnter = false
      if (Array.isArray(loginInfo.role)) {
        for (const role of loginInfo.role) {
          if (role === ROLE.ROLE_SYSTEMMANAGER.value ||
            role === ROLE.ROLE_CHANNEL_ADMIN.value ||
            role === ROLE.ROLE_CHANNEL_ONE.value ||
            role === ROLE.ROLE_CHANNEL_TWO.value) {
            canEnter = true
            break
          }
        }
      }
      return canEnter
    },
    // 用户名登录
    LoginByUsername ({ commit, dispatch }, loginInfo) {
      const username = loginInfo.username.trim()
      return new Promise((resolve, reject) => {
        loginByUsername(username, loginInfo.password).then(response => {
          dispatch('canEnter', response).then(canEnter => {
            if (canEnter) {
              if (response.isActive) {
                setUserInfo(response)
                commit('SET_USER_INFO', response)
              }
            }
            resolve({canEnter, isActive: response.isActive})
          })
        }).catch(err => {
          reject(err)
        })
      })
    },
    // 钉钉扫码登录
    LoginByDingTalk ({ commit, dispatch }, loginInfo) {
      return new Promise((resolve, reject) => {
        dingTalkLogin(loginInfo).then(response => {
          dispatch('canEnter', response).then(canEnter => {
            if (canEnter) {
              if (response.isActive) {
                setUserInfo(response)
                commit('SET_USER_INFO', response)
              }
            }
            resolve({canEnter, isActive: response.isActive})
          })
        }).catch(err => {
          reject(err)
        })
      })
    },

    // 获取用户详细信息

    GetUserDetailInfo ({ commit, state, getters }) {
      return new Promise((resolve, reject) => {
        Promise.all([
          getAllChannel({userId: state.id}),
          getUserDetailInfo(state.id)
        ]).then(responseArr => {
          const channelInfo = responseArr[0] && responseArr[0]._embedded && responseArr[0]._embedded.resources && responseArr[0]._embedded.resources[0]
          const userDetailInfo = responseArr[1]
          if (channelInfo) {
            commit('SET_CHANNEL_INFO', channelInfo)
            commit('SET_NAME', channelInfo.name)
          }
          if (userDetailInfo && userDetailInfo.profileInfo) {
            if (!state.name) {
              commit('SET_NAME', userDetailInfo.profileInfo.name)
            }
            commit('SET_AVATAR', userDetailInfo.profileInfo.profileImage)
            state.userDetailInfoId = userDetailInfo.profileInfo.id
          }
          commit('SET_USER_DETAIL_INFO_GETTED', true)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetUnReadMsg (store) {
      return new Promise((resolve, reject) => {
        getUserMessageList({
          receivingUserId: store.getters.userId,
          size: 5,
          number: 1,
          state: false
        }).then(response => {
          if (response._embedded && Array.isArray(response._embedded.resources)) {
            store.commit('SET_UNREAD_MSG', response._embedded.resources)
          }
          if (response.page) {
            store.commit('SET_UNREAD_MSG_NUM', response.page.totalElements)
          }
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 第三方验证登录
    // LoginByThirdparty({ commit, state }, code) {
    //   return new Promise((resolve, reject) => {
    //     commit('SET_CODE', code)
    //     loginByThirdparty(state.status, state.email, state.code).then(response => {
    //       commit('SET_TOKEN', response.data.token)
    //       setToken(response.data.token)
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

    // 手机APP验证登录
    LoginByApp ({ commit }, token) {
      return new Promise((resolve, reject) => {
        commit('SET_TOKEN', token)
        // setToken(token)
        resolve()
      })
    },

    // 登出
    LogOut ({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout().then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeUserInfo()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 前端 登出
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeUserInfo()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js